export default __webpack_public_path__ + "static/media/Group 1127.afdb76bf.svg";